module.exports = __webpack_public_path__ + "img/sectionCover1.32833180.png";